import { Configuration, SkusApi } from '@/api';
import { SkuAssociation, Skus } from '@/models/Sku';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetSkusQuery = (skuIds?: string[], include?: SkuAssociation[]) => {
  const queryClient = useQueryClient();
  const skusApi = new SkusApi(new Configuration(useAuth));

  const {
    isLoading,
    data: skus,
    error,
  } = useQuery<Skus | null>({
    queryKey: ['skus', skuIds, include],
    queryFn: () => {
      if (!skuIds || skuIds.length === 0) return null;

      return skusApi.findSkus(undefined, { skuId: skuIds }, 0, skuIds.length, undefined, include);
    },
    enabled: !!skuIds && skuIds.length > 0,
  });

  const invalidateQuery = async () => {
    return queryClient.invalidateQueries({
      queryKey: ['skus', skuIds],
    });
  };

  return {
    skus: skus?.items,
    isLoading,
    error,
    invalidateQuery,
  };
};

export default useGetSkusQuery;
